import { Spinner } from '@apollo/orbit';
import React, { useMemo } from 'react';
import { Route, Switch } from 'react-router-dom';

import IconRocket2 from 'src/assets/icon-rocket-2.svg';
import { PageLayout } from 'src/components/common/pageLayout/PageLayout';
import { PageTitle } from 'src/components/common/pageTitle/PageTitle';
import { EmptyState } from 'src/components/emptyState/EmptyState';
import { useRouteParams } from 'src/hooks/useRouteParams';
import { useTrackL1PageView } from 'src/lib/analytics/amplitude/hooks/useTrackL1PageView';

import { useSchema } from '../hooks/useSchema';
import {
  changelogRouteConfig,
  changelogSingleChangeRouteConfig,
} from '../routes';
import { ContinueOnboardingWidget } from '../shared/ContinueOnboardingWidget';

import { ChangeLogOverviewPage } from './changeLogOverviewPage/ChangeLogOverviewPage';
import { SingleChangePage } from './singleChangePage/SingleChangePage';

export const ChangeLogPage = () => {
  const { graphId, graphVariant } = useRouteParams(changelogRouteConfig);
  const graphRef = useMemo(
    () => ({ graphId, graphVariant }),
    [graphId, graphVariant],
  );
  const { activeSchema: graphqlSchema, loadingSchema } = useSchema();

  useTrackL1PageView('changeLogL1', { graphRef });

  if (loadingSchema) {
    return (
      <PageLayout title={<PageTitle title="Changelog" />}>
        <div
          className="h-full"
          style={{ display: 'grid', placeItems: 'center' }}
        >
          <Spinner />
        </div>
      </PageLayout>
    );
  }

  if (!graphqlSchema) {
    return (
      <div className="mt-20 flex flex-1 flex-col items-center">
        <EmptyState
          icon={<IconRocket2 />}
          title="Changelog"
          description="Track what’s changed and when. The changelog helps your team stay in sync as your graph evolves."
        >
          <ContinueOnboardingWidget />
        </EmptyState>
      </div>
    );
  }

  return (
    <PageLayout title={<PageTitle title="Changelog" />}>
      <Switch>
        <Route
          path={changelogRouteConfig.definition}
          exact
          render={() => (
            <ChangeLogOverviewPage
              graphRef={graphRef}
              graphqlSchema={graphqlSchema}
            />
          )}
        />
        <Route
          path={changelogSingleChangeRouteConfig.definition}
          render={() => (
            <SingleChangePage
              graphRef={graphRef}
              graphqlSchema={graphqlSchema}
            />
          )}
        />
      </Switch>
    </PageLayout>
  );
};
